import { getBrandConstants } from '../../utils/brand'; // eslint-disable-line import/no-extraneous-dependencies

const PHONE_NUMBERS = {
  NUMBER: getBrandConstants().number,
  DISPLAY: getBrandConstants().display,
};

export default PHONE_NUMBERS;
